import { createSelector } from "@reduxjs/toolkit";

import { isInternalUser } from "./utils";

import type { RootState } from "Store/configureStore";

const selectApp = (state: RootState) => state?.app;

export const meSelector = createSelector(selectApp, app => {
  return app?.me;
});

export const selectCurrentUserUsername = createSelector(
  meSelector,
  me => me?.username || ""
);

export const selectCurrentUserUUID = createSelector(
  meSelector,
  me => me?.uuid || me?.id || ""
);

export const selectCurrentUserIsInternal = createSelector(meSelector, me =>
  // `email` is what /users/me returns; `mail` covers the legacy /me payload.
  isInternalUser(me?.email || me?.mail)
);

export const selectCurrentUserDisplayName = createSelector(meSelector, me => {
  // The legacy /me payload has `display_name`; /users/me only has
  // `first_name`/`last_name`.
  const composedName = [me?.first_name, me?.last_name]
    .filter(Boolean)
    .join(" ");
  return me?.display_name?.trim() || composedName || me?.username || "";
});

export const selectCurrentUserProjects = createSelector(
  meSelector,
  me => me?.projects
);

export const selectUserProjectById = createSelector(
  selectCurrentUserProjects,
  (_: RootState, params: { projectId: string }) => params,
  (projects, p) => projects?.find(project => project.id === p?.projectId)
);

export const currentRouteSelector = createSelector(
  selectApp,
  app => app.routeHistory.currentRoute
);

export const selectLastRoute = createSelector(
  selectApp,
  app => app.routeHistory.previousRoutes[0]
);
